import type React from "react";

import { SearchMdIcon } from "@/components/Icons/SearchMdIcon";
import type { InputAppearance, InputProps, InputWidth } from "@/design-system/Input";
import { Input } from "@/design-system/Input";

export interface SearchInputProps extends Omit<InputProps, "appearance" | "prefix" | "inputMode" | "type" | "width"> {
  ref?: React.Ref<HTMLInputElement>;
  appearance?: InputAppearance;
  width?: InputWidth;
}
export function SearchInput({ enterKeyHint = "search", ...props }: SearchInputProps): React.ReactNode {
  return <Input prefix={<SearchMdIcon />} inputMode="search" type="search" enterKeyHint={enterKeyHint} {...props} />;
}
